// src/components/Topbar.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  Breadcrumbs,
  Link,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";

function Topbar() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        backgroundColor: "#1A2035",
        borderBottom: "1px solid #4C5365",
      }}
    >
      {/* Left side: Breadcrumbs */}
      <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff" }}>
        <Link
          underline="hover"
          color="inherit"
          href="/dashboard"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Home
        </Link>
        <Typography sx={{ color: "#E63572" }}>Dashboard</Typography>
      </Breadcrumbs>

      {/* Right side: Search and Icons */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#fff" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#fff" },
            },
            input: { color: "#fff" },
          }}
        />
        <IconButton color="inherit">
          <SettingsIcon sx={{ color: "#fff" }} />
        </IconButton>
        <IconButton color="inherit" onClick={handleProfileClick}>
          <AccountCircleIcon sx={{ color: "#fff" }} />
        </IconButton>
      </Box>

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{ sx: { backgroundColor: "#1A2035", color: "#fff" } }}
      >
        <MenuItem
          onClick={() => {
            handleCloseMenu();
            navigate("/profile");
          }}
        >
          My Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCloseMenu();
            handleLogout();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Topbar;
